module.exports = __webpack_public_path__ + "media/images/athletes/1069-35264d46d09d77da9cb8b366190ffc7c.png";